import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MESSAGE_TYPES, type MessageResponse } from '@/entities/conversations';
import { useChatFontSizeClass } from '@/entities/settings';
import { SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { Chat } from '@/shared/ui/Chat';
import { isRuleFeedItem } from '../model/feedItem';
import { BubbleFeedItem } from './BubbleFeedItem';
import { NoteFeedItem } from './NoteFeedItem';
import { RuleFeedItem } from './RuleFeedItem';

type Props = {
  dialogId: number;
  /** Элементы переписки в порядке следования */
  messages: MessageResponse[];
};

/** Переписка текстовой коммуникации: все элементы в порядке следования, каждый облаком по левому краю. */
export const DialogTextFeed: FC<Props> = ({ dialogId, messages }) => {
  const { t } = useTranslation(['dialogs']);
  const textClassName = useChatFontSizeClass();

  if (messages.length === 0) return <p className="p-4 text-sm text-muted-foreground">{t('dialogs:noData')}</p>;

  return (
    // Облака — по ширине ленты: иначе широкая картинка раздвигает ленту за край узкой панели и экрана
    <Chat
      key={dialogId}
      autoDownScroll={false}
      classNames={{ content: 'gap-4 px-4 py-2 md:px-6', scrollArea: SCROLL_AREA_VIEWPORT_BLOCK }}
    >
      {messages.map((message) => {
        if (message.type === MESSAGE_TYPES.NOTE) {
          return <NoteFeedItem key={message.id} message={message} textClassName={textClassName} />;
        }
        if (isRuleFeedItem(message)) {
          return <RuleFeedItem key={message.id} message={message} textClassName={textClassName} />;
        }
        return <BubbleFeedItem key={message.id} message={message} textClassName={textClassName} />;
      })}
    </Chat>
  );
};
